import { ArrowLeftOutlined } from '@ant-design/icons';
import { setCurrentRecordingPath, setSelectedRecordingsIndex } from 'actions/broadcast';
import React, { useEffect, useMemo, useState } from 'react'
import ReactPlayer from 'react-player';
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import ReactPlayerHoc from 'components/ReactPlayerHoc';

function PlayRecordings({ currentRecordingsPath, recordingsData, setCurrentRecordingPath,
    setSelectedRecordingsIndex, selectedRecordingsIndex, cardData, user }) {
    const history = useHistory();

    // Alternate URLs for the same asset, handed over by whoever navigated here
    // (ScheduleDetailsDrawer.js's buildVideoPlaybackUrls). A locally uploaded video can
    // live either as its transcoded HLS rendition or as the raw upload, so try the
    // primary URL and step through the rest as each one fails rather than showing the
    // user a dead player.
    const fallbacks = history.location.state?.playbackFallbacks;
    const [playbackUrl, setPlaybackUrl] = useState(currentRecordingsPath);
    const [remainingUrls, setRemainingUrls] = useState(Array.isArray(fallbacks) ? fallbacks : []);
    useEffect(() => {
        setPlaybackUrl(currentRecordingsPath);
        setRemainingUrls(Array.isArray(fallbacks) ? fallbacks : []);
    }, [currentRecordingsPath]);
    const handlePlaybackError = (error) => {
        if (!remainingUrls.length) {
            console.warn("[PlayRecordings] playback failed, no fallback URLs left", playbackUrl, error);
            return;
        }
        const [next, ...rest] = remainingUrls;
        console.warn("[PlayRecordings] playback failed for", playbackUrl, "- trying", next);
        setPlaybackUrl(next);
        setRemainingUrls(rest);
    };

    const canDownload = user.privilage?.includes('SuperAdmin') || user.privilage?.includes('Admin');
    // Rebuilt on every render this object would hand ReactPlayer a new config each time the
    // HOC's playing/volume state changes, mid-playback.
    const playerConfig = useMemo(() => ({
        file: {
            ...(canDownload ? {} : { attributes: { controlsList: 'nodownload' } }),
            hlsOptions: {
                maxAudioFramesDrift: 100, // Re-enabled to suppress UDP gap jitter in VODs (AudioContext sync prevents the global drift now)
                stretchShortVideoTrack: true,
                enableWorker: true
            }
        }
    }), [canDownload]);
    return (
        <div className="display-flex full-width recordingsPage" style={{ height: "100%", width: "100%" }}>
            {/* <div style={{width:"30%", overflowY:"scroll"}} className="recordingsPageDataWrapper">
                {
                    recordingsData?.map((recording, index)=>(
                        <RecordingsCard name={recording.fileName}
                        key={recording.streamName} 
                        duration={recording.duration}
                        fileSize={recording.fileSize}
                        filePath={recording.url}
                        setCurrentRecordingPath={setCurrentRecordingPath}
                        history={history}
                        isFromModal={false}
                        index = {index}
                        setSelectedRecordingsIndex={setSelectedRecordingsIndex}
                        selectedIndex={selectedRecordingsIndex}
                        />
                    ))
                }
            </div> */}
            {console.log("currentRecordingsPath", currentRecordingsPath)}
            <div className="full-height" style={{ width: "100%", height: "100%" }}>
                <div style={{ width: "100%", padding: 20, fontWeight: '700', fontSize: 20 }}>
                    <ArrowLeftOutlined onClick={() => {
                        const from = history.location.state?.from;
                        if (from?.path) {
                            history.push(from.path, from.state);
                        } else if (typeof from === 'string') {
                            history.push(from);
                        } else {
                            history.goBack();
                        }
                    }} style={{ fontSize: 20, marginRight: 20 }} className="cursor-pointer" />
                    {history.location.state?.recordingTitle || cardData.recordingName || 'Lecture video'}
                </div>
                <ReactPlayerHoc
                    width={"100%"}
                    height={"85%"}
                    style={{ width: "100%", height: "100%" }}
                    config={playerConfig}
                    // Disable right click
                    onContextMenu={e => e.preventDefault()}
                    url={playbackUrl}
                    onError={handlePlaybackError}
                    controls={true}
                    keyboardControls={true}
                />
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    const { currentRecordingsPath, recordingsData, selectedRecordingsIndex } = state.broadcast;
    const { cardData } = state.schedule;
    const { user } = state.session;
    return {
        currentRecordingsPath, recordingsData, selectedRecordingsIndex,
        cardData,
        user
    }
}

const mapDispatchToProps = dispatch => ({
    setCurrentRecordingPath: (filepath) => dispatch(setCurrentRecordingPath(filepath)),
    setSelectedRecordingsIndex: (index) => dispatch(setSelectedRecordingsIndex(index))
})

export default connect(mapStateToProps, mapDispatchToProps)(PlayRecordings);